import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import i18n from "../i18n";

/*
//import Design from "../views/Design.vue";
//import Main from "../views/Main.vue";
import Profile from "../views/profile/Profile.vue";
import ProfileMain from "../views/profile/ProfileMain.vue";
import ProfilePwd from "../views/profile/ProfilePwd.vue";
import ProfileOrder from "../views/profile/ProfileOrder.vue";
import ProfileEdit from "../views/profile/ProfileEdit.vue";
*/

const browserLocale = window.navigator.language;

const supportedLocales = ["zh-TW", "zh-CN", "en"];

let defaultLocale = browserLocale;
const hasLocale = supportedLocales.some(l => l === defaultLocale);
if (!hasLocale) defaultLocale = supportedLocales[0];

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    props: true,
    meta: { isPublic: true },
    redirect: `/${defaultLocale}`,
    beforeEnter: (_to, _from, next) => {
      let locale = defaultLocale;
      const hasLocale = supportedLocales.some(l => l === locale);
      if (!hasLocale) locale = supportedLocales[0];
      next(locale);
    }
  },
  {
    path: "/password",
    redirect: `/${defaultLocale}/password`
  },
  {
    path: "/:locale/password",
    component: () => import("../views/profile/Password.vue"),
    props: true,
    meta: { isPublic: true }
  },
  {
    path: "/:locale",
    beforeEnter: (to, _from, next) => {
      let locale = to.params.locale;
      //const supported_locales = process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',');
      //if (!supported_locales.includes(locale)) return next('en');
      const hasLocale = supportedLocales.some(l => l === locale);
      if (!hasLocale) {
        locale = supportedLocales[0];
        if (i18n.locale !== locale) {
          i18n.locale = locale;
        }
        next(locale + to.path);
      }
      return next();
    },
    component: () => import("../views/Main.vue"),
    props: true,
    meta: { isPublic: true },
    children: [
      {
        path: "",
        props: true,
        meta: { isPublic: true },
        component: () => import("../views/Index.vue")
      },
      {
        path: "faq",
        props: true,
        meta: { isPublic: true },
        component: () => import("../views/QA.vue")
      },
      {
        path: "design",
        component: () => import("../views/Design/Design.vue"),
        children: [
          {
            path: "",
            component: () => import("../views/Design/DesignSelect.vue")
          },
          {
            path: "envs",
            component: () => import("../views/Design/DesignEnv.vue")
          },
          {
            path: "envs/:id",
            component: () => import("../views/Design/DesignEnv.vue")
          }
        ]
      },
      {
        path: "profile",
        component: () => import("../views/profile/Profile.vue"),
        children: [
          {
            path: "",
            component: () => import("../views/profile/ProfileMain.vue")
          },
          {
            path: "resetpassword",
            component: () => import("../views/profile/ProfilePwd.vue")
          },
          {
            path: "order",
            component: () => import("../views/profile/ProfileOrder.vue")
          },
          {
            path: "edit",
            component: () => import("../views/profile/ProfileEdit.vue")
          }
        ]
      },
      {
        path: "order",
        component: () => import("../views/Order/OrderMain.vue"),
        children: [
          {
            path: "cart",
            component: () => import("../views/Order/Cart.vue")
          },
          {
            path: "detail",
            component: () => import("../views/Order/Detail.vue")
          } /*,
          {
            path: "finish",
            component: () => import("../views/Order/Finish.vue")
          }
          */
        ]
      }
    ]
  },
  {
    path: "/:locale/design/editor",
    component: () => import("../views/Design/DesignEditor.vue")
  },
  {
    path: "/:locale/design/editor/:id",
    component: () => import("../views/Design/DesignEditor.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, _from, next) => {
  //console.log(Vue.cookie.get("token"))
  //Vue.cookie.delete('token')
  const locale = to.params.locale;
  if (i18n.locale !== locale) {
    i18n.locale = locale;
  }
  if (!to.meta.isPublic && !Vue.cookies.get("token")) {
    return next(`/${i18n.locale}/`);
  }
  next();
});

export default router;
